import React from 'react';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { ModalBody, ModalTitle, ButtonDiv } from '../css';

import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';

const ModifyOrderModal = (props) => {
  const { secondaryAction, primaryAction } = props;

  return (
    <ModalBody>

      <ModalTitle>{t('WarningTitle')}</ModalTitle>

      <p>{t('ModifyAlert')}</p>

      <ButtonDiv className="row no-gutters">

        <div className="col-sm-12 col-md">
          <SecondaryButton
            name="cancelButton"
            label={t('GoBack')}
            onClick={secondaryAction}
            showArrow={false}
          />
        </div>

        <div className="col-sm-12 col-md">
          <PrimaryButton
            name="cancelOrder"
            label={t('Continue')}
            onClick={primaryAction}
          />
        </div>

      </ButtonDiv>

    </ModalBody>
  );
};

ModifyOrderModal.propTypes = {
  primaryAction: PropTypes.func,
  secondaryAction: PropTypes.func,
};

export default ModifyOrderModal;
